import { render, staticRenderFns } from "./wx.vue?vue&type=template&id=1f4b6b74&scoped=true"
import script from "./wx.vue?vue&type=script&lang=js"
export * from "./wx.vue?vue&type=script&lang=js"
import style0 from "./wx.vue?vue&type=style&index=0&id=1f4b6b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4b6b74",
  null
  
)

export default component.exports